import React from "react";
import { translate } from "react-i18next";
import styled from "styled-components";
import { media } from "../../src/styles/media";
import { Container } from "../../src/components/Grid";

const RootIntroduction = styled.div`
  display: flex;
  padding: 2rem 0 4rem;
  flex-direction: column;

  ${media.desktop`
    padding: 6rem 0 6rem;
    flex-direction: row-reverse;
  `};
`;

const WrapperImage = styled.div`
  padding-top: 86%;
  margin-bottom: 4rem;
  position: relative;
  width: 100%;

  ${media.desktop`
    flex: 0.70;
    padding: 0;
    margin: 0;
  `};
`;

const IphoneWrapper = styled.div`
  background-image: url(/static/images/application/image-0.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  &:before {
    background-color: rgba(63, 76, 213, 0.55);
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    content: "";
  }

  ${media.desktop`
    margin-bottom: 0;
  `};
`;

const Iphone = styled.img`
  top: -10px;
  left: 0;
  position: absolute;
  width: 100%;
`;

const WrapperText = styled.div`
  padding: 0 ${props => props.theme.layout.gutter * 0.75}px;

  ${media.desktop`
    padding: 0 7rem;
    flex: 1;
  `};
`;

const Title = styled.h2`
  color: ${props => props.theme.color.black};
  font-family: ${props => props.theme.font.bold};
  font-size: 3.8rem;
  margin-bottom: 2rem;
  text-transform: uppercase;

  ${media.desktop`
    font-size: 5.5rem;
    line-height: 5.8rem;
  `};
`;

const Content = styled.p`
  color: ${props => props.theme.color.darkGrey};
  font-size: 1.5rem;
  line-height: 2.5rem;
  margin-bottom: 2rem;

  ${media.desktop`
    font-family: ${props => props.theme.font.regular};
    font-size: 1.8rem;
    line-height: 3rem;
    margin-bottom: 3rem;
  `};
`;

const Stores = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.desktop`
    flex-direction: row;
  `};
`;

const Store = styled.a`
  background-image: url(${props => props.background});
  display: inline-block;
  margin-bottom: 1rem;
  height: 50px;
  width: 172px;

  ${media.desktop`
    margin: 0 1rem 0 0;
  `};
`;

const Introduction = ({ t }) => (
  <Container>
    <RootIntroduction>
      <WrapperImage>
        <IphoneWrapper>
          <Iphone src="/static/images/application/iphone.png" />
        </IphoneWrapper>
      </WrapperImage>
      <WrapperText>
        <Title>{t("common:application.intro.title")}</Title>
        <Content>{t("common:application.intro.content")}</Content>
        <Stores>
          <Store
            background="/static/images/application/app_store.jpg"
            href="https://itunes.apple.com/fr/app/grand-h%C3%B4tel-dieu/id1370821641?mt=8"
            target="_blank"
          />
          <Store
            background="/static/images/application/google_play.jpg"
            href="https://play.google.com/store/apps/details?id=com.grandhoteldieu"
            target="_blank"
          />
        </Stores>
      </WrapperText>
    </RootIntroduction>
  </Container>
);

export default translate()(Introduction);
